module.exports = __webpack_public_path__ + "img/works_wechat_anpi_3.8e296c3c.png";